import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
	:root {
		--accessibility-focus-ring-color: #193146;
		--accessibility-focus-ring-width: 1px;
		--accessibility-focus-ring-offset: 1px;
		--accessibility-focus-second-ring-color: #FFFFFF;
		--accessibility-focus-second-ring-width: 1px;
	}
	[data-reduced-motion="true"] * {
		animation-duration: 0.01ms !important;
		animation-iteration-count: 1 !important;
		transition-duration: 0.01ms !important;
		scroll-behavior: auto !important;
	}
	[data-high-contrast="true"] {
		*:focus-visible {
			outline: var(--accessibility-focus-ring-offset) var(--accessibility-focus-ring-color) solid !important;
			box-shadow: 0 0 0 var(--accessibility-focus-second-ring-width) var(--accessibility-focus-second-ring-color) !important;
		}
		[class*="__control"]:focus-within, [class*="Inputstyles__StyledInputWrapper"]:focus-within, [class*="-control"]:focus-within {
			outline: var(--accessibility-focus-ring-offset) var(--accessibility-focus-ring-color) solid !important;
			box-shadow: 0 0 0 var(--accessibility-focus-second-ring-width) var(--accessibility-focus-second-ring-color) !important;
		}
		[class*="__control"]:focus-within input, [class*="Inputstyles__StyledInputWrapper"]:focus-within input, [class*="-control"]:focus-within input {
			outline: none !important;
			box-shadow: none !important;
		}
		[class*="Editablestyles__EditableWrapper"] div:focus-within {
			outline-offset: calc(-1 * (var(--accessibility-focus-ring-offset) + var(--accessibility-focus-ring-width))) !important;
		}
		.navigation-sidebar *:focus-visible {
			outline: var(--accessibility-focus-second-ring-width) var(--accessibility-focus-second-ring-color) solid !important;
			box-shadow: none !important;
			outline-offset: calc(-1 * (var(--accessibility-focus-ring-offset) + var(--accessibility-focus-ring-width))) !important;
		}
		:root {
			--accessibility-focus-ring-width: 4px;
			--accessibility-focus-ring-offset: 4px;
			--accessibility-focus-second-ring-width: 4px;
		}
		.app-container {	
			.event-list .event-title span.tag, .card-header span.tag {
				color: #ffffff !important;
			}
			button[data-variant="primary"], button[data-variant="primary"] span,
			a[data-variant="primary"], a[data-variant="primary"] span,
			button.btn-primary, button.btn-primary span {
				background-color: #6F52FF !important;
				color: #ffffff !important;
			}
			button[data-variant="destructive"], button[data-variant="destructive"] span,
			a[data-variant="destructive"], a[data-variant="destructive"] span,
			button.btn-destructive, button.btn-destructive span {
				background-color: #EF4444 !important;
				color: #FFFFFF !important;
			}
			button[data-variant="secondary"], button[data-variant="secondary"] span,
			a[data-variant="secondary"], a[data-variant="secondary"] span,
			button.btn-secondary, button.btn-secondary span {
				color: #000000 !important;
			}
		}
		.navigation-sidebar {
			a[aria-selected="true"] {
				background-color: #6F52FF !important;
			}
		}
	}
`;
